<div class="login-right glass-effect">
  <a mat-button [routerLink]="['/auth']">Retour</a>
  <h2>{{'contact_us.title'|translate}}</h2>
  <h3>{{'contact_us.subtitle'|translate}}</h3>

  <form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)">
    <ng-container *ngIf="!isAccountCreation">
      <mat-form-field appearance="outline">
        <mat-label>{{'contact_us.name'|translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="name" name="name" #nameField="ngModel" required />
        <mat-icon class="material-symbols-outlined" matSuffix>person</mat-icon>
        <mat-hint *ngIf="!nameField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="isAccountCreation">
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{'contact_us.first_name'|translate}}</mat-label>
          <input matInput type="text" [(ngModel)]="firstName" name="firstName" #firstNameField="ngModel" required />
          <mat-icon class="material-symbols-outlined" matSuffix>person</mat-icon>
          <mat-hint *ngIf="!firstNameField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{'contact_us.last_name'|translate}}</mat-label>
          <input matInput type="text" [(ngModel)]="lastName" name="lastName" #lastNameField="ngModel" required />
          <mat-icon class="material-symbols-outlined" matSuffix>person</mat-icon>
          <mat-hint *ngIf="!lastNameField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
        </mat-form-field>
      </div>
    </ng-container>

    <mat-form-field appearance="outline">
      <mat-label>{{'login.email'|translate}}</mat-label>
      <input matInput type="email" [(ngModel)]="email" name="email" #emailField="ngModel" required />
      <mat-icon class="material-symbols-outlined" matSuffix>mail</mat-icon>
      <mat-hint *ngIf="!emailField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{'contact_us.object'|translate}}</mat-label>
      <mat-select [(ngModel)]="object" name="object" #objectField="ngModel" required>
        <mat-option value="technical_support">{{'contact_us.object_technical_support'|translate}}</mat-option>
        <mat-option value="access_issue">{{'contact_us.object_access_issue'|translate}}</mat-option>
        <mat-option value="suggestion">{{'contact_us.object_suggestion'|translate}}</mat-option>
        <mat-option value="account_creation">{{'contact_us.object_account_creation'|translate}}</mat-option>
      </mat-select>
      <mat-hint *ngIf="!objectField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
    </mat-form-field>

    <ng-container *ngIf="isAccountCreation">
      <mat-form-field appearance="outline">
        <mat-label>{{'contact_us.password'|translate}}</mat-label>
        <input matInput type="password" [(ngModel)]="password" name="password" #passwordField="ngModel" required
          (ngModelChange)="checkPasswordCriteria()" />
        <mat-icon class="material-symbols-outlined" matSuffix>lock</mat-icon>
        <mat-hint *ngIf="!passwordField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
        <mat-hint *ngIf="passwordField.valid && submitted && !isPasswordValid">*{{'contact_us.password_too_weak'|translate}}</mat-hint>
      </mat-form-field>

      <div class="password-criteria">
        <ul>
          <li [class.valid]="passwordCriteria.length">{{'contact_us.password_hint_length'|translate}}</li>
          <li [class.valid]="passwordCriteria.uppercase">{{'contact_us.password_hint_uppercase'|translate}}</li>
          <li [class.valid]="passwordCriteria.lowercase">{{'contact_us.password_hint_lowercase'|translate}}</li>
          <li [class.valid]="passwordCriteria.digit">{{'contact_us.password_hint_digit'|translate}}</li>
          <li [class.valid]="passwordCriteria.noSpaces">{{'contact_us.password_hint_no_spaces'|translate}}</li>
        </ul>
      </div>

      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{'contact_us.position'|translate}}</mat-label>
          <input matInput type="text" [(ngModel)]="position" name="position" #positionField="ngModel" required />
          <mat-icon class="material-symbols-outlined" matSuffix>work</mat-icon>
          <mat-hint *ngIf="!positionField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{'contact_us.company'|translate}}</mat-label>
          <input matInput type="text" [(ngModel)]="company" name="company" #companyField="ngModel" required />
          <mat-icon class="material-symbols-outlined" matSuffix>apartment</mat-icon>
          <mat-hint *ngIf="!companyField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{'contact_us.project_name'|translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="projectName" name="projectName" #projectNameField="ngModel" required />
        <mat-icon class="material-symbols-outlined" matSuffix>engineering</mat-icon>
        <mat-hint *ngIf="!projectNameField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
      </mat-form-field>
    </ng-container>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>{{'contact_us.message'|translate}}</mat-label>
      <textarea matInput [(ngModel)]="message" name="message" #messageField="ngModel" placeholder="" required
        [rows]="isAccountCreation ? 3 : 5"></textarea>
      <mat-hint *ngIf="!messageField.valid && submitted">*{{'contact_us.field_required'|translate}}</mat-hint>
    </mat-form-field>

    <lib-button color="primary" text="{{'contact_us.send'|translate}}" type="submit" [disabled]="isSubmitting"></lib-button>
  </form>
</div>
